package com.veldekar.components.srd.spells

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun CommandDescription() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You speak a one-word command to a creature you can see within range. The target must succeed on a wisdom saving throw or follow the command on its next turn. The spell has no effect if the target is undead, if it doesn't understand your language, or if your command is directly harmful to it.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Some typical commands and their effects follow. You might issue a command other than one described here. If you do so, the GM determines how the target behaves. If the target can't follow your command, the spell ends.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Approach.")
            }
        }
        org.jetbrains.compose.web.dom.Text(" The target moves toward you by the shortest and most direct route, ending its turn if it moves within 5 feet of you.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Drop.")
            }
        }
        org.jetbrains.compose.web.dom.Text(" The target drops whatever it is holding and then ends its turn.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Flee.")
            }
        }
        org.jetbrains.compose.web.dom.Text(" The target spends its turn moving away from you by the fastest available means.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Grovel.")
            }
        }
        org.jetbrains.compose.web.dom.Text(" The target falls prone and then ends its turn.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Halt.")
            }
        }
        org.jetbrains.compose.web.dom.Text(" The target doesn't move and takes no actions. A flying creature stays aloft, provided that it is able to do so. If it must move to stay aloft, it flies the minimum distance needed to remain in the air.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("At Higher Levels.")
        }
        org.jetbrains.compose.web.dom.Text(" When you cast this spell using a spell slot of 2nd level or higher, you can affect one additional creature for each slot level above 1st. The creatures must be within 30 feet of each other when you target them.")
    }
}
